module.exports = __webpack_public_path__ + "img/user-avatar-8.027db3dc.png";